module.exports = __webpack_public_path__ + "img/ic_water_level.9f7dc2bf.png";